var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  0% {\n      transform: scale(1)\n  }\n  50% {\n      opacity: 0.2\n  }\n\n  100% {\n      transform: scale(1.2, 1.6);\n      opacity: 0\n  }\n'], ['\n  0% {\n      transform: scale(1)\n  }\n  50% {\n      opacity: 0.2\n  }\n\n  100% {\n      transform: scale(1.2, 1.6);\n      opacity: 0\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  border-color: ', ';\n  border-radius: ', ';\n  border-style: solid;\n  border-width: ', ';\n  color: #fff;\n  font-size: ', ';\n  font-weight: ', ';\n  cursor: pointer;\n\n  height: ', ';\n\n  line-height: 0px;\n  opacity: 1;\n  outline: none;\n  padding-left: ', ';\n  padding-right: ', ';\n\n  padding-left: ', ';\n\n  padding-right: ', ';\n\n  position: relative;\n  text-rendering: geometricPrecision;\n  transition: all 0.25s ease-in;\n  z-index: auto;\n\n  ', ';\n\n  @media (max-width: 768px) {\n    margin-bottom: ', ';\n  }\n  &:hover {\n    transform: translateY(-2px);\n  }\n  .with-children {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    .children {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .icon {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding-left: ', ';\n      img {\n        max-width: 20px;\n      }\n    }\n  }\n  .no-children {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &[data-color=\'primary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.35);\n    ', ';\n    &:hover {\n      box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),\n        0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);\n    }\n  }\n\n  &[data-color=\'secondary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(52, 120, 92, 0.35);\n    ', ';\n    &:hover {\n      box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),\n        0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);\n    }\n  }\n\n  &[data-color=\'tertiary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(195, 58, 83, 0.35);\n    ', ';\n    &:hover {\n      box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),\n        0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);\n    }\n  }\n\n  &[data-color=\'primary\'],\n  &[data-color=\'secondary\'],\n  &[data-color=\'tertiary\'],\n  .primary,\n  .secondary,\n  .tertiary {\n    color: #fff;\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  &[data-color=\'filled\'] {\n    color: ', ';\n    border-color: ', ';\n    background-color: #fff;\n    box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'ghost\'],\n  &[data-color=\'ghost-secondary\'],\n  &[data-color=\'ghost-tertiary\'] {\n    &:hover {\n      opacity: 0.8;\n    }\n    &:active {\n      opacity: 1;\n    }\n  }\n\n  &[data-color=\'ghost\'],\n  &[data-color=\'ghost-primary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.15);\n    color: ', ';\n    border-color: ', ';\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'ghost-secondary\'] {\n    border-color: ', ';\n    color: ', ';\n    box-shadow: 0 0.25rem 0.55rem rgba(52, 120, 92, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(52, 120, 92, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'ghost-tertiary\'] {\n    color: ', ';\n    border-color: ', ';\n    box-shadow: 0 0.25rem 0.55rem rgba(195, 58, 83, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(195, 58, 83, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'danger\'] {\n    color: #fff;\n    box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.15);\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.35);\n    }\n  }\n\n  &[data-color=\'transparent\'] {\n    color: ', ';\n    &:focus {\n      color: ', ';\n      border-color: transparent;\n    }\n    &:hover {\n      color: ', ';\n      border-color: transparent;\n    }\n  }\n\n  &[data-color=\'danger-ghost\'] {\n    color: ', ';\n    box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.15);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &:disabled,\n  &[disabled] {\n    background-image: none;\n    border: ', ' solid #bbc5c9;\n    background-color: #bbc5c9;\n    color: ', ';\n    cursor: not-allowed;\n    box-shadow: none;\n    &:before {\n      display: none;\n    }\n    &:hover {\n      cursor: not-allowed;\n      opacity: 1;\n      color: ', ';\n      background-color: ', ' !important;\n      background-image: none;\n      border-color: ', ';\n    }\n  }\n\n  &:active {\n    opacity: 1;\n  }\n\n  &:hover {\n    opacity: 0.9;\n    background-color: ', ';\n    background-image: none;\n    border-color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  border-color: ', ';\n  border-radius: ', ';\n  border-style: solid;\n  border-width: ', ';\n  color: #fff;\n  font-size: ', ';\n  font-weight: ', ';\n  cursor: pointer;\n\n  height: ', ';\n\n  line-height: 0px;\n  opacity: 1;\n  outline: none;\n  padding-left: ', ';\n  padding-right: ', ';\n\n  padding-left: ', ';\n\n  padding-right: ', ';\n\n  position: relative;\n  text-rendering: geometricPrecision;\n  transition: all 0.25s ease-in;\n  z-index: auto;\n\n  ', ';\n\n  @media (max-width: 768px) {\n    margin-bottom: ', ';\n  }\n  &:hover {\n    transform: translateY(-2px);\n  }\n  .with-children {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    .children {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .icon {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding-left: ', ';\n      img {\n        max-width: 20px;\n      }\n    }\n  }\n  .no-children {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &[data-color=\'primary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.35);\n    ', ';\n    &:hover {\n      box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),\n        0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);\n    }\n  }\n\n  &[data-color=\'secondary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(52, 120, 92, 0.35);\n    ', ';\n    &:hover {\n      box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),\n        0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);\n    }\n  }\n\n  &[data-color=\'tertiary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(195, 58, 83, 0.35);\n    ', ';\n    &:hover {\n      box-shadow: 0 0.313rem 0.719rem rgba(122, 123, 151, 0.1),\n        0 0.156rem 0.125rem rgba(122, 123, 151, 0.06);\n    }\n  }\n\n  &[data-color=\'primary\'],\n  &[data-color=\'secondary\'],\n  &[data-color=\'tertiary\'],\n  .primary,\n  .secondary,\n  .tertiary {\n    color: #fff;\n    &:hover {\n      color: ', ';\n    }\n  }\n\n  &[data-color=\'filled\'] {\n    color: ', ';\n    border-color: ', ';\n    background-color: #fff;\n    box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'ghost\'],\n  &[data-color=\'ghost-secondary\'],\n  &[data-color=\'ghost-tertiary\'] {\n    &:hover {\n      opacity: 0.8;\n    }\n    &:active {\n      opacity: 1;\n    }\n  }\n\n  &[data-color=\'ghost\'],\n  &[data-color=\'ghost-primary\'] {\n    box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.15);\n    color: ', ';\n    border-color: ', ';\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(57, 115, 173, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'ghost-secondary\'] {\n    border-color: ', ';\n    color: ', ';\n    box-shadow: 0 0.25rem 0.55rem rgba(52, 120, 92, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(52, 120, 92, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'ghost-tertiary\'] {\n    color: ', ';\n    border-color: ', ';\n    box-shadow: 0 0.25rem 0.55rem rgba(195, 58, 83, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(195, 58, 83, 0.35);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &[data-color=\'danger\'] {\n    color: #fff;\n    box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.15);\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.35);\n    }\n  }\n\n  &[data-color=\'transparent\'] {\n    color: ', ';\n    &:focus {\n      color: ', ';\n      border-color: transparent;\n    }\n    &:hover {\n      color: ', ';\n      border-color: transparent;\n    }\n  }\n\n  &[data-color=\'danger-ghost\'] {\n    color: ', ';\n    box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.15);\n    &:focus {\n      color: ', ';\n      border-color: ', ';\n    }\n    &:hover {\n      box-shadow: 0 0.25rem 0.55rem rgba(219, 32, 45, 0.15);\n      color: ', ';\n      border-color: ', ';\n    }\n  }\n\n  &:disabled,\n  &[disabled] {\n    background-image: none;\n    border: ', ' solid #bbc5c9;\n    background-color: #bbc5c9;\n    color: ', ';\n    cursor: not-allowed;\n    box-shadow: none;\n    &:before {\n      display: none;\n    }\n    &:hover {\n      cursor: not-allowed;\n      opacity: 1;\n      color: ', ';\n      background-color: ', ' !important;\n      background-image: none;\n      border-color: ', ';\n    }\n  }\n\n  &:active {\n    opacity: 1;\n  }\n\n  &:hover {\n    opacity: 0.9;\n    background-color: ', ';\n    background-image: none;\n    border-color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n      position: relative;\n      &:before {\n        animation: ', ' 2s ease infinite;\n        border-radius: 12px;\n        position: absolute;\n        content: \'\';\n        z-index: -1;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        top: 0;\n      }\n    '], ['\n      position: relative;\n      &:before {\n        animation: ', ' 2s ease infinite;\n        border-radius: 12px;\n        position: absolute;\n        content: \'\';\n        z-index: -1;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        top: 0;\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n        position: relative;\n        &:before {\n          background: rgba(57, 115, 173, 0.8);\n        }\n      '], ['\n        position: relative;\n        &:before {\n          background: rgba(57, 115, 173, 0.8);\n        }\n      ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n        position: relative;\n        &:before {\n          background: rgba(52, 120, 92, 0.8);\n        }\n      '], ['\n        position: relative;\n        &:before {\n          background: rgba(52, 120, 92, 0.8);\n        }\n      ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n        position: relative;\n        &:before {\n          background: rgba(195, 58, 83, 0.8);\n        }\n      '], ['\n        position: relative;\n        &:before {\n          background: rgba(195, 58, 83, 0.8);\n        }\n      ']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    width: ', ';\n    align-items: center;\n  }\n'], ['\n  display: inline-flex;\n  flex-direction: column;\n  @media (max-width: 768px) {\n    width: ', ';\n    align-items: center;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  margin: 1rem auto 0.5rem auto;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  max-width: 250px;\n'], ['\n  margin: 1rem auto 0.5rem auto;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  max-width: 250px;\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import { isEmpty, isNil, curry } from 'ramda';
import styled, { keyframes, css } from 'styled-components';
import colours from '../../Utils/colours';
import { setColour } from '../../Utils/colours';
import { resolveIcon } from '../../../utils';
import { withTheme } from 'styled-components';
import { inputWeight } from '../../Theme/index';
var pulse = keyframes(_templateObject);
var StyledButton = styled.button(_templateObject2, function (props) {
  return setColour(props, 'backgroundColor', 'dark');
}, function (props) {
  return setColour(props, 'borderColor', 'border_colour');
}, function (props) {
  return props.size === 'large' ? '12px' : props.theme.radius;
}, function (props) {
  return props.size === 'large' ? '2px' : '1px';
}, function (props) {
  return props.customSize ? props.size : props.size === 'large' ? '24px' : '16px';
}, function (props) {
  return inputWeight(props);
}, function (props) {
  return props.size === 'small' && '32px' || props.size === 'large' && '80px' || '48px';
}, function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
}, function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
}, function (props) {
  return props.size === 'small' && '1rem' || props.size === 'large' && '2.5rem' || '1.5rem';
}, function (props) {
  return props.size === 'small' && '1rem' || props.size === 'large' && '2.5rem' || '1.5rem';
}, function (props) {
  return props.throbbing === true && css(_templateObject3, pulse);
}, function (props) {
  return props.inline ? '0px' : '8px';
}, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.throbbing === true && css(_templateObject4);
}, function (props) {
  return props.throbbing === true && css(_templateObject5);
}, function (props) {
  return props.throbbing === true && css(_templateObject6);
}, function (props) {
  return colours(props.theme, props.colour, 'light_text');
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.secondary.base;
}, function (props) {
  return props.theme.colours.secondary.base;
}, function (props) {
  return props.theme.colours.secondary.base;
}, function (props) {
  return props.theme.colours.secondary.base;
}, function (props) {
  return props.theme.colours.secondary.base;
}, function (props) {
  return props.theme.colours.secondary.base;
}, function (props) {
  return props.theme.colours.tertiary.base;
}, function (props) {
  return props.theme.colours.tertiary.base;
}, function (props) {
  return props.theme.colours.tertiary.base;
}, function (props) {
  return props.theme.colours.tertiary.base;
}, function (props) {
  return props.theme.colours.tertiary.base;
}, function (props) {
  return props.theme.colours.tertiary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.danger.base;
}, function (props) {
  return props.theme.colours.danger.base;
}, function (props) {
  return props.theme.colours.danger.base;
}, function (props) {
  return props.theme.colours.danger.base;
}, function (props) {
  return props.theme.colours.danger.base;
}, function (props) {
  return props.theme.border_width;
}, function (props) {
  return colours(props.theme, 'neutral', 'lightest');
}, function (props) {
  return colours(props.theme, 'neutral', 'lightest');
}, function (props) {
  return colours(props.theme, 'neutral', 'light');
}, function (props) {
  return setColour(props, 'borderColor', 'transparent');
}, function (props) {
  return setColour(props, 'backgroundColor', 'base');
}, function (props) {
  return setColour(props, 'borderColor', 'transparent');
});
var ButtonContainer = styled.div(_templateObject7, function (props) {
  return props.inline ? 'auto' : '100%';
});
var Nudge = styled.div(_templateObject8);

var Btn = function (_Component) {
  _inherits(Btn, _Component);

  function Btn() {
    _classCallCheck(this, Btn);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Btn.prototype.render = function render() {
    var _props = this.props,
        colour = _props.colour,
        size = _props.size,
        inline = _props.inline,
        children = _props.children,
        type = _props.type,
        nudge = _props.nudge,
        disabled = _props.disabled,
        rest = _objectWithoutProperties(_props, ['colour', 'size', 'inline', 'children', 'type', 'nudge', 'disabled']);

    var buttonColour = colour ? colour : type;
    var icon = resolveIcon(this.props.theme, this.props.icon);
    var hasIcon = !isNil(icon) && !isEmpty(icon);
    var hasChildren = !isNil(this.props.children) && !isEmpty(this.props.children);
    return React.createElement(ButtonContainer, {
      inline: inline
    }, React.createElement(StyledButton, _extends({
      inline: inline,
      'data-color': buttonColour,
      size: size,
      colour: buttonColour,
      disabled: disabled
    }, rest), hasChildren && React.createElement('span', {
      className: 'with-children'
    }, React.createElement('span', {
      className: 'children'
    }, children), hasIcon && React.createElement('span', {
      className: 'icon'
    }, React.createElement('img', {
      src: icon,
      alt: 'icon'
    }))), !hasChildren && React.createElement('span', {
      className: 'no-children'
    }, hasIcon && React.createElement('span', {
      className: 'icon'
    }, React.createElement('img', {
      src: icon,
      alt: 'icon'
    })))), nudge && React.createElement(Nudge, {
      className: 'small'
    }, nudge));
  };

  return Btn;
}(Component);

var ThemedBtn = withTheme(Btn);
export var Button = function Button(props) {
  return React.createElement(Fragment, null, React.createElement(ThemedBtn, props));
};
var ColourButton = curry(function (colour, props) {
  return React.createElement(Fragment, null, React.createElement(ThemedBtn, _extends({
    className: colour,
    colour: colour,
    size: props.size ? props.size : 'medium'
  }, props)));
});
var SmallButton = curry(function (colour, props) {
  return React.createElement(Fragment, null, React.createElement(ThemedBtn, _extends({
    className: colour,
    colour: colour,
    size: 'small'
  }, props)));
});
var LargeButton = curry(function (colour, props) {
  return React.createElement(Fragment, null, React.createElement(ThemedBtn, _extends({
    className: colour,
    colour: colour,
    size: 'large'
  }, props)));
});
export var SmallPrimaryButton = SmallButton('primary');
export var SmallSecondaryButton = SmallButton('secondary');
export var SmallTertiaryButton = SmallButton('tertiary');
export var SmallNeutralButton = SmallButton('neutral');
export var SmallGhostButton = SmallButton('ghost');
export var SmallGhostSecondaryButton = SmallButton('ghost-secondary');
export var SmallGhostTertiaryButton = SmallButton('ghost-tertiary');
export var SmallFilledButton = SmallButton('filled');
export var SmallDangerButton = SmallButton('danger');
export var PrimaryButton = ColourButton('primary');
export var SecondaryButton = ColourButton('secondary');
export var TertiaryButton = ColourButton('tertiary');
export var GhostButton = ColourButton('ghost');
export var NeutralButton = ColourButton('neutral');
export var GhostSecondaryButton = ColourButton('ghost-secondary');
export var GhostTertiaryButton = ColourButton('ghost-tertiary');
export var FilledButton = ColourButton('filled');
export var DangerButton = ColourButton('danger');
export var TransparentButton = ColourButton('transparent');
export var DangerGhostButton = ColourButton('danger-ghost');
export var LargePrimaryButton = LargeButton('primary');
export var LargeSecondaryButton = LargeButton('secondary');
export var LargeTertiaryButton = LargeButton('tertiary');
export var LargeNeutralButton = LargeButton('neutral');
export var LargeGhostButton = LargeButton('ghost');
export var LargeGhostSecondaryButton = LargeButton('ghost-secondary');
export var LargeGhostTertiaryButton = LargeButton('ghost-tertiary');
export var LargeFilledButton = LargeButton('filled');
export var LargeDangerButton = LargeButton('danger');
var OverrideButton = curry(function (icon, override, props) {
  return React.createElement(Fragment, null, React.createElement(ThemedBtn, _extends({
    size: props.size ? props.size : 'medium',
    icon: icon
  }, props, {
    override: override
  })));
});
export var WhatsappButton = OverrideButton('whatsapp', {
  backgroundColor: '#25D366',
  backgroundImage: '#25D366',
  borderColor: '#25D366'
});
export var FacebookButton = OverrideButton('facebook', {
  backgroundColor: '#3c5a99',
  backgroundImage: '#3c5a99',
  borderColor: '#3c5a99'
});
export var TwitterButton = OverrideButton('twitter', {
  backgroundColor: '#0098f7',
  backgroundImage: '#0098f7',
  borderColor: '#0098f7'
});
export var MessengerButton = OverrideButton('messenger', {
  backgroundColor: '#33ccff',
  backgroundImage: '#33ccff',
  borderColor: '#33ccff'
});
export var GoogleButton = OverrideButton('google', {
  backgroundColor: '#0F9D58',
  backgroundImage: '#0F9D58',
  borderColor: '#0F9D58'
});
export default Button;